import * as React from 'react';
import { Badge, Flex, FlexItem, Tooltip } from '@patternfly/react-core';
import { UserButton } from '@clerk/clerk-react';

const AdminBadge = (): React.ReactElement => (
  <Flex alignItems={{ default: 'alignItemsCenter' }} gap={{ default: 'gapMd' }}>
    <FlexItem>
      <Tooltip content="Admin access">
        <Badge isRead>Admin</Badge>
      </Tooltip>
    </FlexItem>
    <FlexItem>
      <UserButton afterSignOutUrl="/sign-in" />
    </FlexItem>
  </Flex>
);

export default AdminBadge;
